import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import { bool, func } from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { AVISO_PROCESSAMENTO, FECHAR, AGUARDE_PROCESSAMENTO } from '../../constants'

const ModalWrapper = styled.div`
  background-color: rgba(19, 26, 45, 0.5);
  font-size: 18px;

  h2 {
    margin-bottom: 40px;
  }

  p {
    font-size: 16px;
    padding: 0 50px;
  }

  button {
    margin-top: 30px;
    text-align: center;
  }

  a,
  button {
    padding: 15px 28px;

    @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
      width: 100%;
    }
  }

  button {
    @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
      margin-bottom: 10px;
    }
  }
`

const Conteudo = styled.div`
  text-align: center;
`

const ModalAvisoProcessamento = ( { open, onCancelar } ) => {
  return (
    <ModalWrapper open={ open }>
      <Modal
        altura="auto"
        show={ open }
      >
        <Conteudo>
          <h2>
            { AGUARDE_PROCESSAMENTO }
          </h2>
          <p>
            { AVISO_PROCESSAMENTO }
          </p>
          <Button
            onClick={ onCancelar }
            target="_self"
            tema={ Button.BOTAO_CURADORIA }
          >
            { FECHAR }
          </Button>
        </Conteudo>
      </Modal>
    </ModalWrapper>
  )
}

ModalAvisoProcessamento.propTypes = {
  'onCancelar': func,
  'open': bool
}

ModalAvisoProcessamento.defaultProps = {
  'onCancelar': () => {},
  'open': false
}

export default ModalAvisoProcessamento
